/**
 * 테이블 컬럼을 다시 읽었을 때 무엇이 바뀌었나 — DB테이블 노드가 '갱신' 때 기록하고,
 * 그 테이블을 소스·타깃으로 쓰는 데이터처리 노드의 점검(transformLoadCheck)이 읽는다.
 */
import type { Column } from './transformLoad';
import type { ColumnsChange } from './transformLoadCheck';

const key = (s: string) => (s || '').toUpperCase();

export function diffColumns(prev: Column[], next: Column[]): Omit<ColumnsChange, 'at'> {
  const before = new Map(prev.map((c) => [key(c.name), c]));
  const after = new Map(next.map((c) => [key(c.name), c]));
  const added = next.filter((c) => !before.has(key(c.name))).map((c) => c.name);
  const removed = prev.filter((c) => !after.has(key(c.name))).map((c) => c.name);
  const typeChanged = next
    .filter((c) => {
      const old = before.get(key(c.name));
      return old && (old.dataType || '') && (c.dataType || '') && key(old.dataType || '') !== key(c.dataType || '');
    })
    .map((c) => c.name);
  return { added, removed, typeChanged };
}

export function hasChanges(d: Omit<ColumnsChange, 'at'>): boolean {
  return d.added.length > 0 || d.removed.length > 0 || d.typeChanged.length > 0;
}
